import { SimpleGrid } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
// import styled from "./style.module.css";
import styled from "../tenders/style.module.css";
import Container from "react-bootstrap/Container";
import api from "../../utils/ApiMethod";
import img from "../../assets/images/Download.jpeg";
import Styles from "../../styles/Tender.module.css";
import { Helmet } from "react-helmet";
import { CabinetDecisionsData } from "./CabinetDecisionsData";
const CabinetDecisions = () => {
  // const [data, setData] = useState([]);

  // const handleFetchData = async () => {
  //   try {
  //     // const res = await api.fetchData("/noticescirculars");
  //     const res = await api.fetchData("/noticescirculars");

  //     setData(res);
  //     // console.log("Fetched data:", data);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  // useEffect(() => {
  //   handleFetchData();
  // }, []);


  return (
    // <div>
    <div className={styled.Container}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Cabinet Decisions | Bihar State Sports Authority</title>
        <meta
          name="description"
          content="Cabinet Decision List"
        />
      </Helmet>
      <h1 className="pt-2 " style={{ marginBottom: "10px" }}>
        Cabinet Decisions
      </h1>
      {/* input field for search the item */}
      {/* <div class={styled.input_group}>
        <div class="form-outline">
          <input
            type="search"
            id="form1"
            class="form-control"
            placeholder="Search for notice & circulars"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div> */}
      <div style={{ marginTop: "30px" }}>
        <table class="table table-striped ">
          <thead>
            <tr class="table-primary">
              <th className={`${Styles.th}`} scope="col">
                S.No.
              </th>
              <th className={`${Styles.head} text-center`} scope="col">
                Subject
              </th>
              {/* <th className={`${Styles.head}`} scope="col">
              {" "}
              तिथि
            </th>
            <th className={`${Styles.head}`} scope="col">
              अंतिम तिथि
            </th> */}
              <th className={`${Styles.head}`} scope="col">
                Download
              </th>
            </tr>
          </thead>
          <tbody>
            {CabinetDecisionsData &&
              CabinetDecisionsData
                // .filter((item) =>
                //   item.name.toLowerCase().includes(search.toLowerCase())
                // )
                ?.map((item, i) => (
                  <tr>
                    <th scope="row">{i + 1}</th>
                    <td
                      className={Styles.table_cell}
                      style={{ textAlign: "left" }}
                    >
                      {item.title}
                      {item.img ? (
                        <img
                          src={item.img}
                          style={{
                            height: "35px",
                            width: "35px",
                            display: "inline",
                          }}
                          alt="blink"
                        />
                      ) : (
                        ""
                      )}
                    </td>
                    {/* <td
                    className={Styles.table_cell}
                    style={{ textAlign: "left" }}
                  >
                    {item.date}
                  </td>

                  <td
                    className={Styles.table_cell}
                    style={{ textAlign: "left" }}
                  >
                    {item.expiryDate}
                  </td> */}

                    <td
                      className={Styles.table_cell}
                      style={{ textAlign: "left" }}
                    >
                      <a href={item.file} target="_blank">
                        <img className={Styles.table_image} src={img} />
                      </a>
                    </td>
                  </tr>
                ))}
          </tbody>
        </table></div>
    </div>
    // </div>
  );
};

export default CabinetDecisions;
